// src/locales/upload-document-vi.ts (Fixed)
export default {
    upload: {
        // Header
        title: "Tải lên tài liệu mới",
        subtitle: "Chia sẻ kiến thức và kiếm tiền từ tài liệu của bạn",

        // Progress steps
        steps: {
            basicInfo: "Thông tin cơ bản",
            fileUpload: "Tải lên file",
            pricing: "Định giá",
            advanced: "Nâng cao",
            review: "Xem lại"
        },

        // Basic Info Tab
        basicInfo: {
            title: "Thông tin tài liệu",
            subtitle: "Cung cấp thông tin cơ bản về tài liệu của bạn",

            documentTitle: "Tiêu đề tài liệu",
            titlePlaceholder: "Nhập tiêu đề tài liệu...",
            titleHelp: "Tiêu đề rõ ràng giúp tài liệu của bạn dễ tìm thấy hơn",

            description: "Mô tả",
            descriptionPlaceholder: "Mô tả chi tiết nội dung tài liệu...",
            descriptionHelp: "Mô tả chi tiết giúp người đọc hiểu nội dung và quyết định có mua không",

            documentType: "Loại tài liệu",
            documentCategory: "Danh mục",
            subject: "Môn học",
            educationLevel: "Cấp độ giáo dục",
            language: "Ngôn ngữ",
            publicationDate: "Ngày xuất bản",

            languages: {
                vietnamese: "Tiếng Việt",
                english: "Tiếng Anh",
                french: "Tiếng Pháp",
                japanese: "Tiếng Nhật",
                chinese: "Tiếng Trung"
            }
        },

        // File Upload Tab
        fileUpload: {
            title: "Tải lên file",
            subtitle: "Chọn file tài liệu và ảnh bìa",

            selectFile: "Chọn file tài liệu",
            dragDrop: "Kéo thả file hoặc nhấn để chọn",
            supportedFormats: "Định dạng hỗ trợ",
            maxSize: "Kích thước tối đa",
            selectedFile: "File đã chọn",
            fileSize: "Kích thước file",

            coverImage: "Ảnh bìa",
            coverImageHelp: "Ảnh bìa thu hút sẽ có nhiều lượt xem hơn",
            recommendedSize: "Kích thước khuyến nghị: 1200 x 1600 pixels (tỷ lệ 3:4)",

            keywords: "Từ khóa",
            keywordsPlaceholder: "Nhập từ khóa...",
            keywordsHelp: "Ví dụ: toán học, đại số, phương trình, lớp 10",
            addKeyword: "Thêm từ khóa",
            maxKeywords: "Tối đa 10 từ khóa"
        },

        // Pricing Tab
        pricing: {
            title: "Định giá & Chia sẻ",
            subtitle: "Thiết lập giá và chia sẻ lợi nhuận",

            pricingModel: "Mô hình định giá",
            freeDocument: "Tài liệu miễn phí",
            paidDocument: "Tài liệu trả phí",

            price: "Giá (VNĐ)",
            pricePlaceholder: "Nhập giá tài liệu",
            platformFee: "Phí nền tảng: 20%",
            yourEarning: "Bạn sẽ nhận được",

            visibility: "Chế độ hiển thị",
            publicDocument: "Công khai",
            privateDocument: "Riêng tư",
            publicDescription: "Mọi người có thể tìm và xem tài liệu này",
            privateDescription: "Chỉ bạn và người được chia sẻ mới có thể xem",

            coAuthors: "Đồng tác giả",
            coAuthorsHelp: "Chia sẻ bản quyền và lợi nhuận với đồng tác giả",
            authorEmail: "Email đồng tác giả",
            sharePercentage: "Phần trăm chia sẻ",
            addCoAuthor: "Thêm đồng tác giả",
            removeCoAuthor: "Xóa",
            totalShare: "Tổng phần trăm",
            maxShare: "Tổng không được vượt quá 100%"
        },

        // Advanced Tab
        advanced: {
            title: "Cài đặt nâng cao",
            subtitle: "Cấu hình bảo mật và quyền truy cập",

            previewOptions: "Tùy chọn xem trước",
            enablePreview: "Cho phép xem trước",
            previewPages: "Số trang xem trước",
            previewHelp: "Người dùng có thể xem một số trang đầu miễn phí",

            drmOptions: "Quản lý quyền số (DRM)",
            enableDRM: "Bật bảo vệ DRM",
            drmHelp: "Ngăn chặn sao chép và in ấn trái phép",
            allowPrinting: "Cho phép in",
            allowCopying: "Cho phép sao chép văn bản",
            expiryDays: "Hết hạn sau (ngày)",
            expiryHelp: "0 = không bao giờ hết hạn",

            additionalOptions: "Tùy chọn bổ sung",
            addWatermark: "Thêm watermark",
            watermarkHelp: "Thêm watermark bảo vệ bản quyền",
            requireSubscription: "Yêu cầu đăng ký",
            subscriptionHelp: "Chỉ thành viên đăng ký mới có thể truy cập",
            copyrightRegistered: "Đã đăng ký bản quyền",
            copyrightHelp: "Tài liệu đã có đăng ký bản quyền chính thức"
        },

        // Review Tab
        review: {
            title: "Xem lại thông tin",
            subtitle: "Kiểm tra tất cả thông tin trước khi tải lên",

            documentInfo: "Thông tin tài liệu",
            fileInfo: "Thông tin file",
            pricingInfo: "Thông tin định giá",
            advancedInfo: "Cài đặt nâng cao",

            confirmUpload: "Xác nhận tải lên",
            termsAgreement: "Tôi xác nhận tài liệu này không vi phạm bản quyền và đồng ý với Điều khoản dịch vụ",
            publishAfterReview: "Xuất bản sau khi được duyệt",
            saveAsDraft: "Lưu dưới dạng bản nháp",
            reviewTime: "Tài liệu sẽ được xem xét trong vòng 24 giờ"
        },

        // Actions
        actions: {
            next: "Tiếp theo",
            previous: "Quay lại",
            cancel: "Hủy bỏ",
            upload: "Tải lên",
            uploading: "Đang tải lên...",
            preview: "Xem trước",
            saveDraft: "Lưu bản nháp",
            publish: "Xuất bản"
        },

        // Progress
        progress: {
            uploading: "Đang tải lên",
            processing: "Đang xử lý",
            completed: "Hoàn thành",
            cancel: "Hủy tải lên"
        },

        // Messages
        messages: {
            success: "Tải lên tài liệu thành công!",
            successDesc: "Tài liệu của bạn đang được xem xét và sẽ được xuất bản sớm",
            redirecting: "Đang chuyển hướng...",
            uploadError: "Đã xảy ra lỗi khi tải lên",
            invalidFile: "File không hợp lệ",
            fileTooLarge: "File quá lớn",
            networkError: "Lỗi kết nối mạng"
        },

        // Validation
        validation: {
            required: "Trường này là bắt buộc",
            minLength: "Tối thiểu {{min}} ký tự",
            maxLength: "Tối đa {{max}} ký tự",
            minPrice: "Giá tối thiểu {{min}} VNĐ",
            maxPrice: "Giá tối đa {{max}} VNĐ",
            invalidEmail: "Email không hợp lệ",
            invalidFile: "File không hợp lệ",
            maxFileSize: "Kích thước file tối đa {{max}}MB",
            minPages: "Tối thiểu {{min}} trang",
            maxPages: "Tối đa {{max}} trang",
            minDays: "Tối thiểu {{min}} ngày",
            maxDays: "Tối đa {{max}} ngày"
        }
    }
};
